import React from "react";


// list box for selecting primary skill group
const SelectDropDown = (props) => {
  const { options, name, change, value,dropError,tab } = props;
  return (
    <div>
      <select
       typeof="select"
       tabIndex={tab}
        onChange={change}
        style={{  height: "37px", marginTop: "10px", width: "100%" }}
      
        name={name}
        value={value}
      >
        <option hidden value = "">select</option>
        {options.map((option) => {
          return (
            <option  key={option.id} value={option.skillGroup}>
              {option.skillGroup}
            </option>
          );
        })}
      </select>
      <span style={{ color: "red", fontSize: "12px" }}>{dropError}</span>
    </div>
  );
};

export default SelectDropDown;
